module.exports = __webpack_public_path__ + "static/media/logo_kienlongbank.ebaea9e9.svg";